import { BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ConditionElseBetweenLine = styled("div")<BoxProps>(({ theme }) => ({
  position: "absolute",
  borderLeft: "var(--tree-lines-width, 2px) solid var(--if-else-lines-color)",
  width: `calc(var(--if-else-line-offset) + ${theme.spacing(1)})`, //"20px",
  left: "calc(var(--if-else-line-offset) * -1)", //theme.spacing(-1.5),
  top: 0,
  bottom: theme.spacing(-1.5),
}));
